function constructSubmitButtonText(questionViewModel, questionCommands) {
  var areAllQuestionsOptional = questionViewModel.questions.every(function (question) {
    return !question.commonFields.required;
  });
  var areAnyQuestionsAnswered = Object.keys(questionCommands).length > 0;
  /**
   * If all the questions on the page are optional, the `Submit` copy becomes the `Skip` copy
   */

  if (areAllQuestionsOptional && !areAnyQuestionsAnswered) {
    return questionViewModel.skipButtonText;
  } else {
    return questionViewModel.submitButtonText;
  }
}

export default constructSubmitButtonText;
//# sourceMappingURL=constructSubmitButtonText.js.map
